import React from "react";
import ResponsiveTable from "./ResponsiveTabel";
import { ChevronDoubleRightIcon } from "@heroicons/react/24/outline";
import { motion } from "motion/react";
import { fadeInAnimation } from "../../../animation/motionAnimation";

const CaseStudyResponsive = ({ data }) => {
  return (
    <div>
      {data?.map((v, i) => {
        return (
          <div key={i}>
            <div className="overflow-hidden">
              <motion.h2
                {...fadeInAnimation}
                className="font-semibold text-2xl py-4"
              >
                {v?.title}
              </motion.h2>
            </div>
            <div className="flex justify-center">
              <img
                src={v.image_url}
                className="w-full h-[300px] object-center rounded-2xl"
              />
            </div>

            <ResponsiveTable
              Material={v.material}
              Wire={v.wire_diameter}
              Machine={v?.machine}
            />
            <div>
              <h2 className="text-3xl font-semibold my-2">Previous process</h2>
              <ul>
                {v?.improved_process?.split("\n")?.map((val, i) => (
                  <li
                    className="text-xl p-2 flex items-center text-mute-grey text-md"
                    key={i}
                  >
                    {val}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h2 className="text-3xl font-semibold my-2">Improved process </h2>
              <ul>
                {v?.previous_process?.split("\n")?.map((val, i) => (
                  <li
                    className="text-xl p-2 flex items-center text-md text-mute-grey"
                    key={i}
                  >
                    {val}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CaseStudyResponsive;
